import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    ...commonRequestHeaders(),
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const fetchPrManagedRepositories = async () => {
  const response = await axios.get(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/git/repositories`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const fetchRepositoryBranches = async (repositoryId) => {
  const response = await axios.get(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/repositories/${repositoryId}/branches`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const previewSourcePullRequest = async (sourcePullRequestUrl) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/source-pr/preview`,
    { sourcePullRequestUrl },
    { headers: getHeaders() }
  );
  return response.data;
};

export const managePrFiles = async (payload) => {
  const response = await axios.post(
    `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/pr-management/files`,
    payload,
    { headers: getHeaders() }
  );
  return response.data;
};
